module.exports = __webpack_public_path__ + "static/media/ic_vote_helper.f6dc17f6.png";